<template>
    <div class="page-notification">
        <div class="notification-close"></div>

        <div class="notification-inner">
            <div class="notification-message">
                <!-- <button 
                    class="close-notification cta--icon"
                    @click="closeNotification"
                >g</button> -->
                <h4><strong>Neuer Artikel zum Thema <span>Nachhaltigkeit</span></strong></h4>
                <h4 v-if="locale === 'en'">{{ content?.title.en }}</h4>
                <h4 v-if="locale === 'de'">{{ content?.title.de }}</h4>
            </div>

            <div class="notification-actions">
                <ul class="underline-navigation">
                    <li>
                        <a href="" @click.prevent="closeNotification">{{ globals.pagecontent.close }}</a>
                    </li>
                    <li>
                        <NuxtLink
                            :to="localePath(`/${content?.url}`)"
                        >{{ globals.pagecontent.article_button }}</NuxtLink>
                    </li>
                </ul>
            </div>

            <ScrollProgressBar :timeout="9600" />
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        content: {
            type: Object
        }
    })

    const { locale } = useI18n()
    
    const localePath = useLocalePath()
    const globalsStore = useGlobalsStore()

    const requestStore = useRequestStore()
    const { globals } = storeToRefs(requestStore)

    const saveForLater = () => {
        console.log('saved for later')
    }

    const closeNotification = () => {
        globalsStore.changeNotificationState(false)
    }
</script>